import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {AuthRoutes , MasterRoutes} from 'src/app/utilities/routes';
import { AuthService } from '../auth.service';
import { interval } from 'rxjs';
import { timeout } from 'rxjs/operators';
import * as moment from 'moment';
import { UsersType } from '../../utilities/common-file';
import { Messages } from '../../utilities/message';
import { CountdownComponent } from 'ngx-countdown';
import { RolesService } from 'src/app/roles/roles.service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { SystemSearch } from 'src/app/models/System';
import { Config } from 'src/environments/config';

@Component({
    selector: 'app-otp-verify',
    templateUrl: './otp-verify.component.html',
  })
  export class OTPVerifyComponent implements OnInit {

    @ViewChild('countdown', { static: false }) counter: CountdownComponent;
    otpVerifyForm: UntypedFormGroup;
    buttonLoading = false;
    emailId: string;
    showReset = false;
    config = Config;

    private tableData: NzTableData<SystemSearch, any> = new NzTableData
    <SystemSearch, any>(new SystemSearch(), 'name');
    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private authService: AuthService,
        private notification: NzNotificationService,
        private activatedRoute: ActivatedRoute,
        private message: NzNotificationService,
        private roleService: RolesService

      ) {
        this.otpVerifyForm = this.fb.group({
            otp: ['', [ Validators.required]],
            email : ['']
        });
      }
      ngOnInit() {
        this.emailId = this.activatedRoute.snapshot.params.email;
        this.showResendOTP();

    }

    showResendOTP() {
      const seconds = interval(moment().diff(moment().add(3, 'minutes').valueOf(), 'seconds'));
      let final_val = seconds.pipe(timeout(moment(moment().add(3, 'minutes').valueOf()).toDate()));
      final_val.subscribe(e => {
      }, () => {
        this.showReset = true
    });
    }
    resendOTP() {
      this.otpVerifyForm.controls.email.setValue(this.emailId);
      console.log(this.otpVerifyForm.value);
      this.authService.resendOTP(this.otpVerifyForm.value).subscribe((response: any) => {
        this.resetTimer();
        this.showResendOTP();
        this.showReset = false;
        this.message.success(response.message, '', {
          nzKey: 'key'
        });

      });
    }
    resetTimer() {
      this.counter.restart();
    }
    verifyOTP() {
      this.otpVerifyForm.controls.email.setValue(this.emailId);
      this.buttonLoading = true;
      if (this.otpVerifyForm.valid) {
        this.message.info('Please Wait', 'Loading', {
          nzKey: 'key'
        });
        this.authService.verifyOTP(this.otpVerifyForm.value).subscribe((response: any) => {
          this.authService.refreshTokens().subscribe((resForRefreshToken) => {
            if (response.data.role === UsersType.merchantUser || response.data.role === UsersType.locationUser ||
            response.data.role === UsersType.locationManager) {
            this.buttonLoading = false;
            this.message.success(Messages.otpSucess, '', {
               nzKey: 'key'
             });
             this.setAccessModules();   
            this.router.navigate([MasterRoutes.dashboard]);
            } else {
            this.buttonLoading = false;
            this.router.navigate([AuthRoutes.authError]);
           }
           }, err => {
            this.buttonLoading = false;
          });
        }, error => {
          console.log(error);
          this.message.error(error.error.message, '', {
            nzKey: 'key'
          });
          this.buttonLoading = false;
        });
      } else {
        this.buttonLoading = false;
        // tslint:disable-next-line: forin
        for (const i in this.otpVerifyForm.controls) {
          this.otpVerifyForm.controls[i].markAsDirty();
          this.otpVerifyForm.controls[i].updateValueAndValidity();
        }
      }
    }

    setAccessModules() {
      this.roleService.getRoleDetailsById().subscribe((response: any) => {      
        if (response.data.backofficeUserRoleDetails) {
        if (response.data.backofficeUserRoleDetails.length > 0) {
        this.tableData.search.name = 'gst';
        this.tableData.pageIndex = 1;
        this.tableData.pageSize = 1;
        this.tableData.search.appCode = '*';
        this.authService.getSystemWithLimit(this.tableData).subscribe((response: any) => {
          // console.log('response',response);
          if (response.data && response.data.settings.length > 0) {
            if(response.data.settings[0].data.gst){
              localStorage.setItem('gst','true');
              localStorage.setItem('hst',this.config.hst);
            }
          } 
          else {
          localStorage.setItem('gst','false');
          localStorage.setItem('hst',this.config.hst);

          }
        }, (err) => {
        });
        this.tableData.search.name = 'monthly_transfer_fee';
        this.tableData.pageIndex = 1;
        this.tableData.pageSize = 1;
        this.tableData.search.appCode = '*';
        this.authService.getSystemWithLimit(this.tableData).subscribe((response: any) => {
          if (response.data && response.data.settings.length > 0) {
               localStorage.setItem('monthly_transfer_fee',response.data.settings[0].data.isMonthlyTransferFee);
           } 
        }, (err) => {
        });
          this.authService.setRoleAccessModule((JSON.stringify(response.data.backofficeUserRoleDetails).toString()));
          this.router.navigate([MasterRoutes.dashboard]);
        } else {
          this.authService.setRoleAccessModule((JSON.stringify([])).toString());
          this.router.navigate([MasterRoutes.dashboard]);
        }
      } else {
        this.authService.setRoleAccessModule((JSON.stringify([])).toString());
        this.router.navigate([MasterRoutes.dashboard]);
      }
      }, error => {
        this.router.navigate([MasterRoutes.dashboard]);
        if (error.error.message == Messages.noData) {
          this.authService.setRoleAccessModule((JSON.stringify([])).toString());
          this.router.navigate([MasterRoutes.dashboard]);
        }
      });
  
    }

goToLogin() {
  this.router.navigate([AuthRoutes.login]);
}
arrayOfImgUrls = [
  'assets/slider/slider-1@2x.jpg',
  'assets/slider/slider-2@2x.jpg',
  'assets/slider/slider-3@2x.jpg',
  'assets/slider/slider-4@2x.jpg',

]
  forgotPassword(): void {
  //   if (this.otpVerifyForm.invalid) {
  //     this.otpVerifyForm.markAllAsTouched();
  //     return;
  //   }

  //   const payload = this.otpVerifyForm.value;
  //   console.log('OTP Verify submit', payload);

  //   // call API / emit event / navigate
   }

  }
